import { IDropdownMenuItem } from '@vivli/shared/infrastructure/interface';

export const useEnumDropdownMapper = (enumToMap: object, valueAsNum?: boolean): IDropdownMenuItem[] => {
    return Object.keys(enumToMap)
        .map((key) => ({
            title: enumToMap[key],
            value: !valueAsNum ? key : parseInt(key),
        }))
        .filter(({ title }) => typeof title === 'string');
};
